import React from 'react';
import { Check, TrendingUp, Users, Zap, Shield } from 'lucide-react';

const PlanBenefits = ({ plan }) => {
  const isPremium = plan?.planType === 'premium';
  const isFamily = plan?.planType === 'family';

  const benefits = [
    {
      icon: Zap,
      title: 'Unlimited Symptom Tracking',
      description: 'Track symptoms without any daily or monthly limits',
      available: true
    },
    {
      icon: TrendingUp,
      title: 'Advanced Analytics',
      description: 'Access detailed insights and pattern analysis',
      available: plan?.features?.advanced_analytics
    },
    {
      icon: Users,
      title: 'Caregiver Management',
      description: `Connect with ${plan?.limits?.caregiver_connections === -1 ? 'unlimited' : plan?.limits?.caregiver_connections} caregiver${plan?.limits?.caregiver_connections !== 1 ? 's' : ''}`,
      available: plan?.features?.caregiver_management
    },
    {
      icon: Shield,
      title: 'Priority Support',
      description: 'Get faster response times from our support team',
      available: plan?.features?.priority_support
    }
  ];

  const activeBenefits = benefits?.filter(b => b?.available);

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Your Plan Benefits</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {activeBenefits?.map((benefit, index) => {
          const IconComponent = benefit?.icon;
          return (
            <div 
              key={index}
              className="flex items-start p-4 bg-green-50 border border-green-200 rounded-lg"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-3">
                <IconComponent className="w-5 h-5 text-green-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-gray-900 mb-1">{benefit?.title}</h3>
                <p className="text-xs text-gray-600">{benefit?.description}</p>
              </div>
              <Check className="w-5 h-5 text-green-600 flex-shrink-0 ml-2" />
            </div>
          );
        })}
      </div>
      {/* Feature Limits Summary */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900 mb-3">Feature Limits</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="text-center p-3 bg-gray-50 rounded-lg">
            <p className="text-2xl font-bold text-gray-900">
              {plan?.limits?.symptom_history_days === -1 ? '∞' : plan?.limits?.symptom_history_days}
            </p>
            <p className="text-xs text-gray-600 mt-1">Days of History</p>
          </div>
          <div className="text-center p-3 bg-gray-50 rounded-lg">
            <p className="text-2xl font-bold text-gray-900">
              {plan?.limits?.monthly_exports === -1 ? '∞' : plan?.limits?.monthly_exports}
            </p>
            <p className="text-xs text-gray-600 mt-1">Monthly Exports</p>
          </div>
          <div className="text-center p-3 bg-gray-50 rounded-lg">
            <p className="text-2xl font-bold text-gray-900">
              {plan?.limits?.caregiver_connections === -1 ? '∞' : plan?.limits?.caregiver_connections}
            </p>
            <p className="text-xs text-gray-600 mt-1">Caregiver Connections</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanBenefits;